import { sendAuthenticatedAsyncRequest } from "services/AsyncRequestService";

export function fetchTestDataCatalog(onSuccess, onFailure) {
  sendAuthenticatedAsyncRequest("/test-data/catalog", "GET", null, onSuccess, onFailure);
}

export function fetchTestDataBatchGenerationResult(batchUuid, onSuccess, onFailure) {
  sendAuthenticatedAsyncRequest(
    `/test-data/batches/${batchUuid}/generation-result`,
    "GET",
    null,
    onSuccess,
    onFailure
  );
}

export function generateTestDataBatch(body, onSuccess, onFailure) {
  sendAuthenticatedAsyncRequest("/test-data/batches", "POST", body, onSuccess, onFailure);
}

export function uploadTestDataFax(formData, onSuccess, onFailure) {
  sendAuthenticatedAsyncRequest("/test-data/faxes", "POST", formData, onSuccess, onFailure);
}

export function fetchTestDataBatches(status, onSuccess, onFailure) {
  const query = status ? `?status=${encodeURIComponent(status)}` : "";
  sendAuthenticatedAsyncRequest(
    `/test-data/batches${query}`,
    "GET",
    null,
    onSuccess,
    onFailure
  );
}

export function fetchTestDataBatch(batchUuid, onSuccess, onFailure) {
  sendAuthenticatedAsyncRequest(
    `/test-data/batches/${batchUuid}`,
    "GET",
    null,
    onSuccess,
    onFailure
  );
}

export function cleanupTestDataBatch(batchUuid, onSuccess, onFailure) {
  sendAuthenticatedAsyncRequest(
    `/test-data/batches/${batchUuid}`,
    "DELETE",
    null,
    onSuccess,
    onFailure
  );
}
